var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirectMailCampaignSummary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: 58.125,
    viewBox: "0 0 330.223 58.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3124",
    "data-name": "Group 3124",
    transform: "translate(-550.139 -2034.875)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 74.736,
    height: 27.961,
    transform: "translate(550.264 2035)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1564",
    "data-name": "Rectangle 1564",
    width: 74.736,
    height: 27.961,
    transform: "translate(635.263 2035)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1565",
    "data-name": "Rectangle 1565",
    width: 74.736,
    height: 27.961,
    transform: "translate(720.263 2035)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1566",
    "data-name": "Rectangle 1566",
    width: 74.736,
    height: 27.961,
    transform: "translate(805.5 2035)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("text", {
    id: "_1_650",
    "data-name": "$1,650",
    transform: "translate(584.544 2054)",
    fill: "#7f7f7f",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.027,
    y: 0
  }, "$1,650")), /*#__PURE__*/React.createElement("text", {
    id: "_6_500",
    "data-name": "$6,500",
    transform: "translate(669.544 2054)",
    fill: "#7f7f7f",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.027,
    y: 0
  }, "$6,500")), /*#__PURE__*/React.createElement("text", {
    id: "_4_400",
    "data-name": "$4,400",
    transform: "translate(754.544 2054)",
    fill: "#7f7f7f",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.027,
    y: 0
  }, "$4,400")), /*#__PURE__*/React.createElement("text", {
    id: "_324",
    "data-name": "$324",
    transform: "translate(843 2054)",
    fill: "#7f7f7f",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.723,
    y: 0
  }, "$324")), /*#__PURE__*/React.createElement("text", {
    id: "Estimated_Revenue",
    "data-name": "Estimated Revenue",
    transform: "translate(672.743 2076)",
    fill: "#329998",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22.471,
    y: 0
  }, "Estimated"), /*#__PURE__*/React.createElement("tspan", {
    x: -18.931,
    y: 14
  }, "Revenue")), /*#__PURE__*/React.createElement("text", {
    id: "Budget_Per_Mailing",
    "data-name": "Budget Per Mailing",
    transform: "translate(586.743 2076)",
    fill: "#329998",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.776,
    y: 0
  }, "Budget"), /*#__PURE__*/React.createElement("tspan", {
    x: -25.022,
    y: 14
  }, "Per Mailing")), /*#__PURE__*/React.createElement("text", {
    id: "Per_Patient_Acquisition_Cost",
    "data-name": "Per Patient Acquisition Cost",
    transform: "translate(843 2076)",
    fill: "#329998",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24.468,
    y: 0
  }, "Per Patient"), /*#__PURE__*/React.createElement("tspan", {
    x: -36.494,
    y: 14
  }, "Acquisition Cost")), /*#__PURE__*/React.createElement("text", {
    id: "ROI",
    transform: "translate(759.795 2076)",
    fill: "#329998",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.876,
    y: 0
  }, "ROI")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectMailCampaignSummary);
export default __webpack_public_path__ + "static/media/directMailCampaignSummary.44249114.svg";
export { ForwardRef as ReactComponent };